export function removeScrollOnScrim() {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    const documentComputedStyle = getComputedStyle(document.body);
    const initialRightPadding = documentComputedStyle.getPropertyValue("padding-right");

    const initialDocumentStyle = {
        overflow: documentComputedStyle.overflow,
        paddingRight: initialRightPadding,
    };

    Object.assign(document.body.style, {
        overflow: "hidden",
        paddingRight: `${parseFloat(initialRightPadding) + scrollbarWidth}px`
    });
    return {
        scrollbarWidth,
        restore: () => Object.assign(document.body.style, initialDocumentStyle),
    };
}
